import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';

export type Props = {
  url: string | null | undefined;
  description: string;
};

const AdminPdfGallery: React.FC<Props> = ({ url, description }) => {
  const isValid =
    url &&
    !url.toString().includes('null') &&
    !url.toString().includes('undefined') &&
    url.trim() !== '';

  return (
    <Card>
      <CardHeader>
        <h4>{description}</h4>
      </CardHeader>
      <CardBody>
        {isValid ? (
          <a href={url as string} target="_blank" rel="noreferrer">
            <div
              className="d-flex align-items-center p-3"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: 8,
                gap: 12,
                cursor: 'pointer',
              }}
            >
              <i
                className="fa fa-file-pdf"
                style={{ fontSize: 32, color: '#e74c3c' }}
              />
              <div>
                <p className="mb-0 font-weight-bold text-dark">
                  Ver documento
                </p>
                <small className="text-muted">Abrir en nueva pestaña</small>
              </div>
              <i className="fa fa-external-link-alt ml-auto text-muted" />
            </div>
          </a>
        ) : (
          <p className="text-muted mb-0">No hay archivos actualmente</p>
        )}
      </CardBody>
    </Card>
  );
};

export default AdminPdfGallery;
